<template>
  <div>
    <v-container>
      <Breadcrumbs :breadcrumbs="breadcrumbs"/>
    </v-container>
    <v-container v-if="!employee">
      <v-row class="d-flex align-center justify-space-between">
        <v-col cols="1" class="pr-0">
          <v-skeleton-loader type="avatar"></v-skeleton-loader>
        </v-col>
        <v-col cols="9" class="pl-0">
          <v-skeleton-loader type="heading"></v-skeleton-loader>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <v-skeleton-loader type="button"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
        <v-col cols="6"></v-col>
        <v-col cols="2">
          <v-skeleton-loader type="text"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-for="i in 3" :key="i">
        <v-col v-for="i in 3" :key="i" cols="4">
          <v-skeleton-loader type="list-item-avatar-two-line">
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="employee">
      <v-row class="d-flex align-center justify-space-between">
        <v-col class="grow">
          <v-row class="d-flex align-center">
            <v-col class="shrink">
              <span v-if="avatarLoading">
                <v-skeleton-loader type="avatar"></v-skeleton-loader>
                <v-progress-linear rounded :value="avatarProgress"></v-progress-linear>
              </span>
              <span v-else class="cursor-pointer">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                    >
                      <EmployeeAvatar @click.native="updateAvatar" :employee="employee"/>
                    </div>
                  </template>
                  <span>Refresh avatar from slack</span>
                </v-tooltip>
              </span>
            </v-col>
            <v-col class="grow">
              <h1>
                {{ employee.fields.Name }}
                <v-chip 
                  v-if="employee.fields.Status === 'Inactive'" 
                  color="error"
                  class="text-uppercase mr-2"
                >
                  Inactive
                </v-chip>
                <v-tooltip v-if="employee.fields['Ignore In Upload']" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip 
                      color="primary"
                      outlined
                      class="text-uppercase"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Updated Manually
                    </v-chip>
                  </template>
                  <span>
                    You must manually update this employee in the directory if 
                    their employment status changes
                  </span>
                </v-tooltip>
              </h1>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="d-flex justify-end shrink">
          <EmployeeForm
            method="edit"
            :employee="employee"
            methodTitle="Edit"
            icon="mdi-pencil"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <InfoList :employee="employee" :employees="employees" />
        </v-col>
        <v-col>
          <Sessions :sessions="sessionsCheckedIn" :showCurriculum="true" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import EmployeeAvatar from '@/components/employee/Avatar'
  import EmployeeForm from '@/components/employee/Form'
  import InfoList from '@/components/employee/InfoList'
  import Sessions from '@/components/session/Table'
  
  export default {
    name: 'Employee',
    components: {
      Breadcrumbs,
      EmployeeAvatar,
      EmployeeForm,
      InfoList,
      Sessions
    },
    data: () => ({
      avatarLoading: false,
      avatarProgress: 0
    }),
    created () {
      if (this.employees.length === 0) {
        this.$store.dispatch('getRecords', {
          table: 'Employees',
          view: 'All Employees',
          dispatch: 'setEmployees'
        })
      }
      if (this.sessions.length === 0) {
        this.$store.dispatch('getRecords', {
          table: 'Sessions',
          view: 'All Sessions',
          dispatch: 'setSessions'
        })
      }
    },
    computed: {
      avatar () {
        return this.employee ? this.employee.fields['Avatar'][0].url : ''
      },
      breadcrumbs () {
        return [
          {
            text: 'Directory',
            disabled: false,
            to: {
              name: 'Employee Directory'
            }
          },
          {
            text: this.employee ? this.employee.fields.Name : 'Loading...',
            disabled: true
          }
        ]
      },
      employees () {
        return this.$store.getters.getEmployees
      },
      employee () {
        return this.employees.find(e => {
          return e.id === this.$route.params.id
        })
      },
      sessions () {
        return this.$store.getters.getSessions.filter(s => {
          if (this.employee.fields.Sessions) {
            return this.employee.fields.Sessions.includes(s.id)
          }
        })
      },
      sessionsCheckedIn () {
        return this.sessions.filter(s => {
          if (this.employee.fields.Sessions) {
            return this.employee.fields['Sessions Checked In']?.includes(s.id)
          }
        })
      }
    },
    
    methods: {
      async updateAvatar () {
        console.log('updated avatar')
        if (this.avatarLoading) return false
        this.avatarLoading = true
        this.avatarProgress = 0
        await this.$store.dispatch('updateEmployeeAvatar', {
          employee: this.employee
        })
        const avatarLoadingTime = 30
        let timeLeft = 30;
        const countdown = () => {
          if (timeLeft == -1) {
            clearTimeout(timerId);
            this.avatarLoading = false
          } else {
            this.avatarProgress = 100 - (timeLeft / avatarLoadingTime * 100)
            timeLeft--;
          }
        }
        let timerId = setInterval(countdown, 1000);
      }
    }
  }
</script>
